import { z } from 'zod';
import { sizeSchema, coordinateSchema, fontSizeSchema } from '../../../Shared.js';
import { numberSchema } from '../schemas.js';

var InputTypes = /* @__PURE__ */ ((InputTypes2) => {
  InputTypes2["INPUT"] = "input";
  InputTypes2["TEXTAREA"] = "textarea";
  return InputTypes2;
})(InputTypes || {});
const inputItemSchema = z.object({
  kind: z.literal("input"),
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  type: z.nativeEnum(InputTypes),
  placeholder: z.string(),
  characterCapacity: z.coerce.number(),
  maxLength: z.coerce.number().optional(),
  settings: z.object({
    movable: z.boolean().default(false),
    cloneable: z.boolean().default(false),
    hideDragHandle: z.boolean().optional(),
    usePlaceholderAsDefaultValue: z.boolean().optional()
  }).nullish().default({ cloneable: false, movable: false }),
  style: z.object({
    mockDefaultBrowserPadding: z.boolean().optional(),
    background: z.object({
      color: z.string(),
      opacity: z.number().optional()
    }),
    border: z.object({
      style: z.string(),
      width: numberSchema(1),
      color: z.string(),
      radius: z.number().optional()
    }).optional(),
    font: z.object({
      color: z.string().optional(),
      family: z.string().optional(),
      size: z.union([z.number(), fontSizeSchema])
    })
  }).nullish().default({ background: { color: "#fff" }, font: { size: "medium" } })
});

export { InputTypes, inputItemSchema };
//# sourceMappingURL=Input.js.map
